import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { ApiErrors } from '@api/constants';
import {
  ResponseSubmitEvicertia,
  ResponseBulkSignEvicertia,
  ResponseQuerySignEvicertia,
} from '@api/models';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HireDepositService {
  private productCodeSubject = new BehaviorSubject<string>(null);
  productCode$ = this.productCodeSubject.asObservable();

  constructor(private http: HttpClient) {}

  setProductCode(productCode: string) {
    this.productCodeSubject.next(productCode);
  }

  newHiring(productid: string) {
    const params = { productid };
    return this.http.post(
      `${environment.apiBasePath}${environment.endpoints.deposit.newHiring}`,
      null,
      { params }
    );
  }

  getPdfContract(productCode: string) {
    const params = { productCode };
    return this.http.get(
      `${environment.apiBasePath}${environment.endpoints.deposit.getPdfContract}`,
      { params }
    );
  }

  // proceso de firma
  startSignProcessSubmit(productCode: string) {
    const params = { productCode };
    return this.http
      .post<ResponseSubmitEvicertia>(
        `${environment.apiBasePath}${environment.endpoints.sign.startSignProcessSubmit}`,
        null,
        { params }
      )
      .pipe(
        map((data) => {
          if (data?.code === ApiErrors.ERROR_SUBMIT) {
            throw {
              errorCode: data?.code,
              message: data?.code,
            };
          }

          return data?.data[0]?.uniqueId;
        })
      );
  }

  startSignProcessBulkSign(productCode: string) {
    const params = { productCode };
    return this.http
      .post<ResponseBulkSignEvicertia>(
        `${environment.apiBasePath}${environment.endpoints.sign.startSignProcessBulkSign}`,
        null,
        { params }
      )
      .pipe(
        map((data) => {
          if (
            data?.code === ApiErrors.ERROR_BULKSIGN ||
            data?.code === ApiErrors.ERROR_BULKSIGN_REQUESTNEWSUBMIT
          ) {
            throw { errorCode: data?.code, message: data?.code };
          }

          return data?.data[0];
        })
      );
  }

  querySignProcess(productCode: string) {
    const params = { productCode };
    return this.http.post<ResponseQuerySignEvicertia>(
      `${environment.apiBasePath}${environment.endpoints.sign.querySignProcess}`,
      null,
      { params }
    );
  }
}
